import { InsuranceService } from './../../../../core/services/insurance.service';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { BreadcrumbComponent } from '../../../../shared/components/breadcrumb/breadcrumb.component';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { ModalOpenClaimComponent } from '../../components/modal-open-claim/modal-open-claim.component';
import { ModalNewClaimComponent } from '../../components/modal-new-claim/modal-new-claim.component';
import { ISiniestroRequest } from '@interfaces/siniestro-request.interface';
import { ISiniestroResponse } from '@interfaces/siniestro-response.interface';
import { DataService } from 'src/app/core/services/data.service';
import { IValidarSiniestro } from '@interfaces/validar-siniestro.interface';

@Component({
  selector: 'aig-claims-management',
  imports: [
    BreadcrumbComponent,
    RouterModule,
    CommonModule,
    ModalOpenClaimComponent,
    ModalNewClaimComponent,
  ],
  templateUrl: './claims-management.component.html',
  styleUrl: './claims-management.component.scss',
})
export class ClaimsManagementComponent implements OnInit {
  public visibleVerSiniestrosModal: boolean = false;
  public visibleNewClaimModal: boolean = false;

  idPoliza!: number;
  num_documento!: string;

  public claims: ISiniestroResponse[] = [];

  isPolicyActive: boolean = false;

  constructor(
    private insuranceService: InsuranceService,
    private dataService: DataService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.idPoliza = this.dataService.getPoliza();
    this.num_documento = this.dataService.getNumDocumento();

    if (this.idPoliza !== undefined && this.idPoliza > 0)
      this.isPolicyActive = true;

    // Está comentado para poder navegar desde la poliza inexistente de prueba
    // Lo malo que no se vé ningún dato con la póliza inexistente

    // if (!this.idPoliza || this.idPoliza === 0) {
    //   // 🚨 Redirigir si idPoliza no es válido
    //   this.router.navigate(['/area-cliente']); // <-- ajusta esta ruta
    //   return;
    // }

    this.obtenerSiniestro();
    console.log(this.isPolicyActive);
  }

  public obtenerSiniestro() {
    console.log(this.idPoliza);
    if (this.idPoliza === undefined ||this.idPoliza === 0) {
      this.insuranceService
        .obtenerSiniestros({ numDocumento: this.num_documento })
        .subscribe((result) => {
          this.claims = result;
          this.cdr.detectChanges();
        });
    } else {
      this.insuranceService
        .obtenerSiniestros({ idPoliza: this.idPoliza })
        .subscribe((result) => {
          this.claims = result;

          this.cdr.detectChanges(); // 🔁 Forzar detección de cambios
        });
    }
  }

  //Siniestros falseados
  // public claimDto : ISiniestroResponse[] = [
  //   {
  //     idExpediente: 1,
  //     idPoliza: 1,
  //     numExpediente: "23423666",
  //     fechaCreacion: "2025/01/01", // formato DD/MM/YYYY, cadena
  //     idEstadoExpediente: 2,
  //     estadoExpediente: "Abierto",
  //     permiteDocumentacion: true,
  //   },
  //   {
  //     idExpediente: 2,
  //     idPoliza: 2,
  //     numExpediente: "98253666",
  //     fechaCreacion: "2025/01/01", // formato DD/MM/YYYY, cadena
  //     fechaCierre: "2025/08/01", // formato DD/MM/YYYY, cadena nullable
  //     idEstadoExpediente: 3,
  //     estadoExpediente: "Cancelado",
  //     permiteDocumentacion: false,
  //   },
  //   {
  //     idExpediente: 3,
  //     idPoliza: 3,
  //     numExpediente: "62336642",
  //     fechaCreacion: "2024/08/01", // formato DD/MM/YYYY, cadena
  //     fechaCierre: "2025/08/01", // formato DD/MM/YYYY, cadena nullable
  //     idEstadoExpediente: 4,
  //     estadoExpediente: "Finalizado",
  //     resolucion: "Reembolso económico realizado",
  //     importeTransferencia: "420€",
  //     permiteDocumentacion: false,
  //   },
  // ]

  //Filtro para saber si hay abierta algun siniestro
  // claimOpen = this.claimDto.filter(c => c.idEstadoExpediente === 1);
  // isClaimOpen = this.claimOpen.length != 0;

  //Filtro para saber si hay algun siniestro
  // isClaim = this.claimDto.length != 0;

  /** Devuelve si existe al menos un siniestro */
  get isClaim(): boolean {
    return this.claims.length > 0;
  }

  /** Devuelve si hay siniestros abiertos (idEstadoExpediente === 1) */
  get isClaimOpen(): boolean {
    return this.claims.some((c) => c.idEstadoExpediente === 1);
  }

  claimState(arg: number): string {
    switch (arg) {
      case 2:
        return '';
      case 3:
        return 'cancel';
      case 4:
        return 'finish';
      default:
        return '';
    }
  }

  public abrirSiniestroRechazado(data: IValidarSiniestro) {
    const request: ISiniestroRequest = {
      idPoliza: data.idPoliza,
      puedeAbrirSiniestro: false,
      siniestroCurso: data.siniestroCurso,
      estadoPoliza: data.estadoPoliza,
    };

    //console.log(request);

    this.insuranceService.aperturaSiniestro(request).subscribe({
      next: (response) => {
        //console.log('Respuesta:', response);
        // this.isloading = false;
        //console.log(this.visibleVerSiniestrosModal);
        this.visibleVerSiniestrosModal = true; // avanza al último paso de confirmación
      },
      error: (err) => {
        //console.log('Error:', err);
        // this.isloading = false;
        // this.submiterror = 'ha ocurrido un error, por favor revisa los datos e inténtalo de nuevo.';
        // puedes mostrar el error en el template
      },
    });
  }

  public goToDetailsClaim(claim: ISiniestroResponse) {
    this.router.navigate(['/area-cliente/gestion-siniestros/estado'], {
      state: { claim: claim },
    });
  }

  /* Aquí abre la redireccion de añadir nueva claim pero tienes que validar de otra forma */
  public OpenNewClaim() {
    this.insuranceService
      .validarAperturaSiniestro(this.idPoliza)
      .subscribe((data) => {
        if (data.estadoPoliza == 1 && data.siniestroCurso == false) {
          this.visibleNewClaimModal = true;
        } else {
          this.visibleVerSiniestrosModal = true;
        }
      });
  }

  public CloseNewClaim() {
    this.visibleVerSiniestrosModal = false;
    this.visibleNewClaimModal = false;
    this.obtenerSiniestro();
  }
}
